import { Button, Checkbox, Radio } from "antd";
import React, { useEffect, useState } from "react";

const ReportConfiguration = ({
  summaryPage,
  handleSummaryPageChange,
  showAvgValues,
  handleAvgValueChange,
  reportConfig,
  handleReportConfigChange,
  DEFAULT_REPORT_CONFIG,
}) => {
  // Map UI field names to API field names
  const fieldMapping = {
    "Arc Current": "current",
    "Arc Volts": "volts",
    Frequency: "frequency",
    Target: "target",
    "Horizontal Bias": "horizontal_bias",
    "Arc Impedance": "arc_impedance",
    "Travel Speed": "travel_speed",
    "Wire Speed": "wire_speed",
    Heat: "heat",
    "True Energy": "true_energy",
    "Oscillation Width": "oscillation_width",
    "Total Wire Consumed": "total_wire_consumed",
  };

  const [selectAllChecked, setSelectAllChecked] = useState(false);

  useEffect(() => {
    const configFields = Object.keys(reportConfig).filter(
      (key) => key !== "summary_page" && key !== "is_high_low_avg_required"
    );
    const allSelected = configFields.every((key) => reportConfig[key]);
    setSelectAllChecked(allSelected);
  }, [reportConfig]);

  const handleSelectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectAllChecked(checked);
    if (checked) {
      Object.keys(reportConfig).forEach((key) => {
        if (key !== "is_high_low_avg_required") {
          handleReportConfigChange(key, true);
        }
      });
    } else {
      Object.keys(DEFAULT_REPORT_CONFIG).forEach((key) => {
        handleReportConfigChange(key, DEFAULT_REPORT_CONFIG[key]);
      });
    }
  };

  const handleCheckboxChange = (uiField) => {
    const apiField = fieldMapping[uiField];
    const currentValue = reportConfig[apiField];
    handleReportConfigChange(apiField, !currentValue);
  };

  // Report configuration fields in display order
  const reportFields = [
    "Summary Page",
    "Arc Current",
    "Arc Volts",
    "Frequency",
    "Target",
    "Horizontal Bias",
    "Arc Impedance",
    "Travel Speed",
    "Wire Speed",
    "Heat",
    "True Energy",
    "Oscillation Width",
    "Total Wire Consumed",
  ];

  return (
    <div className="report-config-content">
      <div className="report-params-table">
        <div className="report-table-body">
          <div className="report-table-second-header">
            <p className="report-table-second-header-text">
              Please select the required parameters to generate the report
            </p>
            <div className="avg-switch-container">
              <Radio.Group
                value={showAvgValues ? "lowAvgHigh" : "avg"}
                onChange={(e) =>
                  handleAvgValueChange(e.target.value === "lowAvgHigh")
                }
              >
                <Radio value="lowAvgHigh" className="radio-button">
                  Low/Avg/High
                </Radio>
                <Radio value="avg" className="radio-button">
                  Avg
                </Radio>
              </Radio.Group>
            </div>
          </div>

          <div className="report-table-select-all">
            <Checkbox
              checked={selectAllChecked}
              onChange={handleSelectAllChange}
            >
              Select all
            </Checkbox>
          </div>

          {reportFields.map((uiField) =>
            uiField === "Summary Page" ? (
              <div key="summary-page-button" className="report-table-row-units">
                <div className="config-col">
                  <Button
                    type={summaryPage ? "primary" : "default"}
                    className={
                      summaryPage
                        ? "report-table-row-units-button-enabled"
                        : "report-table-row-units-button-disabled"
                    }
                    onClick={() => handleSummaryPageChange(!summaryPage)}
                  >
                    {uiField}
                  </Button>
                </div>
              </div>
            ) : (
              (() => {
                const apiField = fieldMapping[uiField];
                const isEnabled = reportConfig[apiField];
                return (
                  <div
                    key={apiField + "-button"}
                    className="report-table-row-units"
                  >
                    <div className="config-col">
                      <Button
                        type={isEnabled ? "primary" : "default"}
                        className={
                          isEnabled
                            ? "report-table-row-units-button-enabled"
                            : "report-table-row-units-button-disabled"
                        }
                        onClick={() => handleCheckboxChange(uiField)}
                      >
                        {uiField}
                      </Button>
                    </div>
                  </div>
                );
              })()
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportConfiguration;
